import {noop} from '@sail/utils';
import {createContext} from 'react';

import type {PerformanceMonitorTrackStart} from 'src/types';

export default createContext<PerformanceMonitorTrackStart>(() => noop);
